import { AfterViewInit, Component, OnDestroy, OnInit, viewChild } from '@angular/core';
import { MatDialogModule } from '@angular/material/dialog';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule, MatIconRegistry } from '@angular/material/icon';
import { MatListModule } from '@angular/material/list';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatButtonToggleModule } from '@angular/material/button-toggle';
import { CommonModule } from '@angular/common';
import { MatStepper, MatStepperModule } from '@angular/material/stepper';
import { FormsModule } from '@angular/forms';
import { UserinfoContactComponent } from '../userinfo-contact/userinfo-contact.component';
import { trigger, state, style, transition, animate } from '@angular/animations';
import { MatDialogRef } from '@angular/material/dialog';
import { DomSanitizer } from '@angular/platform-browser';

import { CONTACT, ADVANTAGES, FEATURES } from '../data';
import { Subscription } from 'rxjs';
import { CoordinatesSystem, ScreenWidthBreakpoints } from '../../../../state-management/model/enums/screen-size.enums';
import { ScreensizeStateService } from '../../../../state-management/services/screensize-state.service';
import { WebsiteStateService } from '../../../../state-management/services/website-state.service';

@Component({
  selector: 'app-userinfo-content',
  imports: [
    UserinfoContactComponent,
    MatStepperModule,
    FormsModule,
    MatButtonModule,
    MatDialogModule,
    MatListModule,
    MatExpansionModule,
    MatIconModule,
    MatButtonToggleModule,
    CommonModule,
    MatIconModule],
  templateUrl: './userinfo-content.component.html',
  styleUrl: './userinfo-content.component.scss',
  animations: [
    trigger('dialogAnimation', [
      state('void', style({ opacity: 0, transform: 'translateY(100%)' })),
      state('*', style({ opacity: 1, transform: 'translateY(0)' })),
      transition('void => *', [
        animate('0.5s ease-out')
      ]),
      transition('* => void', [
        animate('0.5s ease-in', style({ opacity: 0, transform: 'translateY(100%)' }))
      ])
    ])
  ]
})

export class UserinfoContentComponent implements OnInit, AfterViewInit, OnDestroy {
  private stepperSubscription: Subscription = new Subscription();
  readonly stepper = viewChild.required<MatStepper>('stepper');

  public CONTACT = CONTACT;
  public ADVANTAGES = ADVANTAGES;
  public FEATURES = FEATURES;

  // selectedFrequency: string = 'twoyear';
  // price: number = 0;
  // onetimeprice: number = 0;
  // oldonetimeprice: number = 199;
  // oneyearMonthlyPrice: number = 29.99; // Setze den monatlichen Preis bei monatlicher Zahlung
  // twoyearMonthlyPrice: number = 19.99; // Setze den monatlichen Preis bei jährlicher Zahlung (z.B. mit Rabatt)
  
  public showContactDetails = false;
  public isSmallScreen$ = this.screenSize.isScreenSize(CoordinatesSystem.ScreenWidth, ScreenWidthBreakpoints.XSmall);

  public isFirstStep = true;
  public isLastStep = false;

  public ownerTitle = this.websiteStateService.ownerFirstName() || ""

  constructor(
    public dialog: MatDialogRef<UserinfoContentComponent>,
    private screenSize: ScreensizeStateService,
    private matIconRegistry: MatIconRegistry,
    private domSanitizer: DomSanitizer,
    private websiteStateService: WebsiteStateService
  ) {
    this.matIconRegistry.addSvgIcon('whatsapp', this.domSanitizer.bypassSecurityTrustResourceUrl('assets/icons/whatsapp.svg'));
    // this.updatePrice();
  }

  ngOnInit() { 
  }

  ngAfterViewInit() {
    this.stepperSubscription = this.stepper().selectionChange.subscribe(() => {
      this.scrollToTop();
    });
  }

  ngOnDestroy() {
    if (this.stepperSubscription) this.stepperSubscription.unsubscribe();
  }

  goPrevious() {
    this.stepper().previous();
  }

  goNext() {
    this.stepper().next();
  }

  showContact() {
    this.showContactDetails = true;
  }

  hideContact() {
    this.showContactDetails = false;
    this.isFirstStep = true; // Hard reset to first step
    this.isLastStep = false;
  }

  onStepChange($event: number) {
    this.isFirstStep = $event === 0;
    this.isLastStep = $event === this.stepper()._steps.length - 1;
  }

  // updatePrice() {
  //   if (this.selectedFrequency === 'twoyear') {
  //     this.price = this.twoyearMonthlyPrice;
  //   } else {
  //     this.price = this.oneyearMonthlyPrice;
  //   }
  // }

  // formatPrice(price: number): string {
  //   return price.toFixed(2).replace('.', ',') + '€'; // Formatiere den Preis und füge das Symbol hinzu
  // }

  closeDialog(): void {
    this.dialog.close();
  }

  scrollToTop() {
    const dialogContent = document.querySelector('mat-dialog-content');
    if (dialogContent) {
      dialogContent.scrollTop = 0;
    }
  }
}